import type { GetCreditLedgerPdfResponse } from '@vy/api-definition';
import { GetCreditLedgerPdfResponseSchema } from '@vy/api-definition';
import type { UseMutationOptions } from 'react-query';
import { useMutation } from 'react-query';
import { getPrivateApi } from '../services/api';

export type DownloadCreditNotePdfRequest = {
  creditLedgerId: string;
};

export function useGetCreditNotePdf(
  options?: UseMutationOptions<GetCreditLedgerPdfResponse, unknown, DownloadCreditNotePdfRequest>,
) {
  return useMutation({
    mutationFn: async ({ creditLedgerId }) => {
      const api = getPrivateApi();

      const response = await api.getCreditLedgePdf({ creditLedgerId });

      return GetCreditLedgerPdfResponseSchema.parse(response);
    },
    ...options,
  });
}
